/* The mockup's `.ph`, `.h1` and `.sub`. */
.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-block-end: var(--space-6);
}

.title {
  margin: 0;
  font-size: var(--font-size-24);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
  outline: none;
}

.subtitle {
  margin: 0;
  color: var(--text-muted);
}

/* The subtitle and, on its line, a small aside (a help link). */
.subline {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-1) var(--space-3);
}
